import { apiClient } from "../../base/ApiClient";

export const getAreas = async () => {
  const response = await apiClient.get("/schedule/sublocations/");
  return response.data;
};
